import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M22 20V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2h6",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(_Circle, { cx: "16", cy: "19", r: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M16 11v-1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M16 17v-2", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "FolderArchive";
const FolderArchive = memo(themed(Icon));
export {
  FolderArchive
};
//# sourceMappingURL=folder-archive.js.map
